import { MEETINGS_ENV_CONFIG_KEYS, statusColorMapping } from './consts';
import getEnvConfig from './helpers/getEnvConfig';
import { padStart } from './helpers/utils';

const getPropsFromEntity = ({ entity, env, region, projectId, T }) => {
  const { itemId: id, status, orderIndex, topic, meeting } = entity;
  const numInSeries = padStart(meeting.numInSeries);
  const title = `${T.translate('UNDER')} ${topic.name} ${T.translate('TOPIC')} ${T.translate(
    'IN'
  )} ${numInSeries} ${meeting.title}`;
  const userFriendlyId = `${T.translate('ITEM')} ${orderIndex}`;

  const path = window.location.pathname.toLowerCase();
  let origin = '';

  if (path.includes('/rfis')) {
    origin = 'rfi_item_reference';
  } else if (path.includes('/issues')) {
    origin = 'issue_item_reference';
  }

  const deeplinkUrl = `${getEnvConfig(
    env,
    region,
    MEETINGS_ENV_CONFIG_KEYS.MEETINGS_FE
  )}/projects/${projectId}/meetings/${meeting.id}?filter[item]=${id}&view_origin=${origin}`;

  const statusColor = status ? statusColorMapping[status] : null;
  const statusText = status ? T.translate(`STATUS_${status.toUpperCase()}`) : null;

  return {
    entityTypeName: T.translate('MEETING_ITEM'),
    title,
    userFriendlyId,
    deeplinkUrl,
    statusColor,
    statusText
  };
};

export default getPropsFromEntity;
